module.exports = __webpack_public_path__ + "static/media/IlotC_synthese_5.0d525072.webp";